import React from 'react';
import { translate } from 'react-i18next';

import ShiftDetailBlock from 'components/ScheduleSidebar/ShiftDetailBlock.js';
import EmployeeActions from 'actions/EmployeeActions.js';
import UserActions from 'actions/UserActions.js';

class SidebarShiftBid extends React.Component {
  constructor(props) {
    super(props);

    this.onShiftById = this.onShiftById.bind(this);
    this.onLoadUserData = this.onLoadUserData.bind(this);
    this.onAcceptOffer = this.onAcceptOffer.bind(this);
    this.onLoadConflictShifts = this.onLoadConflictShifts.bind(this);
    this.loadingUser = true;
    this.loadingShift = true;
    this.conflictShift = null;
    this.shiftStartDate = null;
    this.shiftEndDate = null;
    this.shiftID = null;

    this.state = {
      user: {},
      shift: {},
      shiftDetails: {},
      bidDetails: {},
      startTime: '',
      endTime: '',
      loaded: false,
      conflict: null,
    };
  }

  hasAllLoaded() {
    if (!this.loadingUser && !this.loadingShift) {
      this.setState({
        loaded: true,
      });
    }
  }

  componentWillUnmount() {
    UserStore.off('user:load:success', this.onLoadUserData);
    ShiftStore.off('shift_by_id:load:success', this.onShiftById);
    ShiftStore.off('shift_by_date:load:success', this.onLoadConflictShifts);
    ShiftStore.off('shift_by_date:load:success', this.onLoadConflictShifts);
  }

  componentDidMount() {
    this.state.bidDetails = this.props.bidData;

    const userData = ExchangesStore.getExchangeUser(this.props.bidData.user_id);
    // Why would the userData be empty? Commenting out for now.
    // if (_.isEmpty(userData)) {
    //   UserActions.getUser(this.props.bidData.user_id);
    //   UserStore.on('user:load:success', this.onLoadUserData);
    // } else {
    //   this.loadingUser = false;
    // }
    this.loadingUser = false;
    this.shiftID = !Utils.isNotDefined(this.props.bidData.shift_id)
      ? this.props.bidData.shift_id
      : this.props.bidData.id;
    const shiftData = ExchangesStore.getExchangeByShiftId(this.shiftID);
    if (_.isEmpty(shiftData)) {
      EmployeeActions.getShiftById(this.shiftID);
      ShiftStore.on('shift_by_id:load:success', this.onShiftById);
    } else {
      var shiftDetailData = shiftData.shift_details;
      if (Utils.isNotDefined(shiftDetailData)) {
        shiftDetailData = ExchangesStore.getExchangeShiftDetailsByShiftId(shiftData.shift_id);
      }
      var startTimeData = '';
      var endTimeData = '';
      startTimeData = moment(shiftDetailData.start_time)
        .tz(shiftDetailData.time_zone)
        .format('h:mm a');
      endTimeData = moment(shiftDetailData.end_time)
        .tz(shiftDetailData.time_zone)
        .format('h:mm a');
      var hideEnd = shiftDetailData.hide_end_time;
      this.loadingShift = false;

      const today = moment(this.props.shiftDate);
      const currentMonth = moment(today).format('YYYY-MM');
      const shiftMonth = moment(shiftDetailData.start_time)
        .tz(shiftDetailData.time_zone)
        .format('YYYY-MM');
      this.shiftStartDate = moment(shiftDetailData.start_time).tz(
        Utils.getCoreUser().inferred_time_zone,
      );
      this.shiftEndDate = moment(shiftDetailData.end_time).tz(Utils.getCoreUser().inferred_time_zone);
      if (currentMonth === shiftMonth) {
        this.conflictShift = ShiftStore.getShiftByDate(
          this.shiftStartDate.tz(shiftDetailData.time_zone),
        );
      } else {
        ShiftStore.on('shift_by_date:load:success', this.onLoadConflictShifts);
        EmployeeActions.getShiftByDate(this.shiftStartDate.format(), this.shiftEndDate.format());
      }
    }

    this.setState({
      user: userData,
      shift: shiftData,
      shiftDetails: shiftDetailData,
      startTime: startTimeData,
      endTime: !hideEnd ? endTimeData : this.props.t('SidebarShiftBid.tbd'),
      conflict: this.conflictShift,
    });
    this.props.onBidLoaded(this.state.shiftDetails, this, this.state.bidDetails);

    this.hasAllLoaded();
  }

  onLoadConflictShifts(collection, response) {
    ShiftStore.off('shift_by_date:load:success', this.onLoadConflictShifts);
    const responseDate = !Utils.isNotDefined(response[0]) ? response[0].date : null;
    this.conflictShift = ShiftStore.getShiftByDate(this.shiftStartDate);

    if (this.conflictShift != null) {
      this.setState({ conflict: this.conflictShift });
    }
  }

  onAcceptOffer(e) {
    if (EmployeeActions) {
      let exchangeID = this.props.bidData.exchange_id;
      if (_.isUndefined(exchangeID)) {
        const exchange = ExchangesStore.getExchangeByShiftId(this.props.bidData.id);
        exchangeID = exchange.id;
      }
      EmployeeActions.acceptBidOffer(
        exchangeID,
        this.props.bidData.id,
        this.props.bidData.user_id,
        this.shiftID,
        false,
      );
    }
  }

  onShiftById(response) {
    if (response && response.data && response.data.id == this.shiftID) {
      const startTimeData = moment(response.data.start_time)
        .tz(response.data.time_zone)
        .format('h:mm a');
      const endTimeData = moment(response.data.end_time)
        .tz(response.data.time_zone)
        .format('h:mm a');
      const hideEnd = response.data.hide_end_time;

      const today = moment(this.props.shiftDate);
      const currentMonth = moment(today).format('YYYY-MM');
      const shiftMonth = moment(response.data.start_time)
        .tz(response.data.time_zone)
        .format('YYYY-MM');
      this.shiftStartDate = moment(response.data.start_time).tz(
        Utils.getCoreUser().inferred_time_zone,
      );
      this.shiftEndDate = moment(response.data.end_time).tz(Utils.getCoreUser().inferred_time_zone);
      if (currentMonth === shiftMonth) {
        this.conflictShift = ShiftStore.getShiftByDate(
          this.shiftStartDate.tz(response.data.time_zone),
        );
      } else {
        ShiftStore.on('shift_by_date:load:success', this.onLoadConflictShifts);
        EmployeeActions.getShiftByDate(this.shiftStartDate.format(), this.shiftEndDate.format());
      }
      this.setState({
        shiftDetails: response.data,
        startTime: startTimeData,
        endTime: !hideEnd ? endTimeData : this.props.t('SidebarShiftBid.tbd'),
        conflict: this.conflictShift,
      });
      this.props.onBidLoaded(this.state.shiftDetails, this, this.state.bidDetails);
      this.loadingShift = false;
      this.hasAllLoaded();
    }
  }

  onLoadUserData(response) {
    if (response.id == this.props.bidData.user_id) {
      this.setState({
        user: response,
      });
      this.loadingUser = false;
      this.hasAllLoaded();
    }
  }

  _checkForExchangeOverlap(exchange, shifts) {
    if (_.isEmpty(shifts) || exchange.drop) {
      return true;
    }
    const len = shifts.length;
    let overlapped = false;
    for (let i = 0; i < len; i++) {
      const shift = shifts[i];
      if (shift.id !== this.props.parentShiftID) {
        const selectedShiftStart = moment(shift.start_time).tz(shift.time_zone);
        const selectedShiftEnd = moment(shift.end_time).tz(shift.time_zone);
        const shiftRange = moment.range(
          moment(selectedShiftStart.toDate()),
          moment(selectedShiftEnd.toDate()),
        );
        const exchangerStart = moment(exchange.start_time).tz(exchange.time_zone);
        const exchangerEnd = moment(exchange.end_time).tz(exchange.time_zone);
        const exchangeRange = moment.range(
          moment(exchangerStart.toDate()),
          moment(exchangerEnd.toDate()),
        );
        const isBetween = shiftRange.overlaps(exchangeRange);

        if (isBetween) {
          overlapped = true;
        }
      } else {
        overlapped = false;
      }
    }
    return overlapped;
  }

  render() {
    const { state } = this;

    if (!this.state.loaded) {
      return false;
    }

    let acceptButton = (
      <button
        className="calendar-input-button accept-offer"
        onClick={e => this.onAcceptOffer(e)}
        key={_.uniqueId()}
      >
        {this.props.t('SidebarShiftBid.accept')}
      </button>
    );
    if (
      this.props.exchangeType == 'exchange'
      && this.state.shiftDetails.user_id == Utils.getCoreUser().id
    ) {
      acceptButton = [];
    }
    if (this.conflictShift != null) {
      const startDate = moment(this.state.shiftDetails.start_time).tz(
        this.state.shiftDetails.time_zone,
      );
      const endDate = moment(this.state.shiftDetails.end_time).tz(
        this.state.shiftDetails.time_zone,
      );
      const compareStartDate = moment(this.conflictShift.start_time).tz(
        this.conflictShift.time_zone,
      );
      const compareEndDate = moment(this.conflictShift.end_time).tz(this.conflictShift.time_zone);

      const hasConflict = this._checkForExchangeOverlap(this.state.shiftDetails, [
        this.conflictShift,
      ]);

      if (hasConflict) {
        acceptButton = (
          <button
            className="calendar-input-button accept-offer disabled"
            disabled
            key={_.uniqueId()}
          >
            {this.props.t('SidebarShiftBid.schedule_conflict')}
          </button>
        );
      }

      if (
        this.props.exchangeType == 'exchange'
        && this.state.shiftDetails.user_id == Utils.getCoreUser().id
      ) {
        acceptButton = [];
      }
    }

    let breaks = null;
    let notes = null;

    if (
      !Utils.isNotDefined(this.state.shiftDetails)
      && !Utils.isNotDefined(this.state.shiftDetails.breaks)
    ) {
      breaks = Utils.formatUnformattedBreaks(this.state.shiftDetails.breaks);
    }

    if (
      !Utils.isNotDefined(this.state.shiftDetails)
      && !Utils.isNotDefined(this.state.shiftDetails.shift_notes)
    ) {
      notes = this.state.shiftDetails.shift_notes;
    }

    let shiftDate = '';
    if (this.state.shiftDetails && this.state.shiftDetails.start_time) {
      const momentObj = moment(this.state.shiftDetails.start_time)
                  .tz(this.state.shiftDetails.time_zone);
      shiftDate = Utils.formatLocaleDate(momentObj);
    }

    this.props.onResizeSidebar();

    return (
      <div className="calendar-input exchange-offer">
        <span className="calendar-input-bullet exchange">{this.props.t('SidebarShiftBid.exchange_offer')}</span>
        <div className="shift-detail-content">
          <p className="shift-detail-title">
            {this.state.user.name}
            <br />
            {!Utils.isNotDefined(this.state.shiftDetails.name) ? this.state.shiftDetails.name : ''}
            <br />
            {shiftDate}
            <br />
            {this.state.startTime}
            {' – '}
            {this.state.endTime}
          </p>

          {!Utils.isNotDefined(breaks) && (
            <p className="shift-detail-breaks">
              {this.props.t('SidebarShiftBid.breaks')}:&nbsp;
              {breaks}
            </p>
          )}
          <ShiftDetailBlock
            departmentID={this.state.shiftDetails ? this.state.shiftDetails.department_id : ''}
            locationID={this.state.shiftDetails ? this.state.shiftDetails.location_id : ''}
            position={this.state.shiftDetails ? this.state.shiftDetails.position : ''}
            job_site_name={this.state.shiftDetails ? this.state.shiftDetails.job_site_name : ''}
            job_site_address={
              this.state.shiftDetails ? this.state.shiftDetails.job_site_address : ''
            }
          />
          {!Utils.isNotDefined(notes) && (
            <div className="shift-detail-notes-container">
              <p className="shift-detail-title">{this.props.t('SidebarShiftBid.notes').toUpperCase()}</p>
              <p className="shift-detail-notes">{notes}</p>
            </div>
          )}
        </div>
        <div className="full-flex-container exchange-buttons">{acceptButton}</div>
      </div>
    );
  }
}

export default translate()(SidebarShiftBid);
